import { SvgIcon, useTheme } from "@mui/material";

const PersonIcon = ({ color, fontSize }: any) => {

    const theme = useTheme();

    return (
        <SvgIcon sx={{ fontSize: fontSize || 32, mt: .3, mx: 1 }}>
            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
                <g clipPath="url(#clip0_565_10069)">
                    <path d="M6 30H26V25C25.9978 23.1442 25.2596 21.3649 23.9474 20.0526C22.6351 18.7404 20.8558 18.0022 19 18H13C11.1442 18.0022 9.36493 18.7404 8.05265 20.0526C6.74037 21.3649 6.00217 23.1442 6 25V30Z" fill={color || theme.palette.secondary.contrastText} />
                    <path d="M9 9C9 10.3845 9.41054 11.7378 10.1797 12.889C10.9489 14.0401 12.0421 14.9373 13.3212 15.4672C14.6003 15.997 16.0078 16.1356 17.3656 15.8655C18.7235 15.5954 19.9708 14.9287 20.9497 13.9497C21.9287 12.9708 22.5954 11.7235 22.8655 10.3656C23.1356 9.00776 22.997 7.6003 22.4672 6.32122C21.9373 5.04213 21.0401 3.94888 19.889 3.17971C18.7378 2.41054 17.3845 2 16 2C14.1435 2 12.363 2.7375 11.0503 4.05025C9.7375 5.36301 9 7.14348 9 9Z" fill={color || theme.palette.secondary.contrastText} />
                </g>
                <defs>
                    <clipPath id="clip0_565_10069">
                        <rect width="32" height="32" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </SvgIcon>
    );

};

export default PersonIcon;